/**
 * Swiper + accordion + frame preview helpers for Customize Fine Art Print.
 */
(() => {
  if (window.__fineArtCustomizer25Loaded) return;
  window.__fineArtCustomizer25Loaded = true;

  const FRAME_CLASSES = ['frame-BLACK', 'frame-WHITE', 'frame-NONE'];
  const customArtState = {
    images: [],
    frame: 'NONE',
  };

  function normalizeFrameValue(value) {
    const frame = String(value || '').trim().toUpperCase();
    if (!frame || frame === 'PRINT ONLY') return 'NONE';
    if (frame === 'BLACK') return 'BLACK';
    if (frame === 'WHITE') return 'WHITE';
    return frame;
  }

  function frameClassFor(value) {
    const frame = normalizeFrameValue(value);
    if (frame === 'BLACK') return 'frame-BLACK';
    if (frame === 'WHITE') return 'frame-WHITE';
    return 'frame-NONE';
  }

  function findFrameImageIndex(images, frameValue) {
    if (!Array.isArray(images) || !images.length) return -1;

    const frame = normalizeFrameValue(frameValue);
    const matchers = {
      NONE: [/noframe/i, /no_frame/i, /no-frame/i],
      WHITE: [/white_print/i, /white-print/i, /whiteframe/i, /white_frame/i],
      BLACK: [/blk_print/i, /black_print/i, /black-print/i, /blackframe/i, /black_frame/i],
    };

    const patterns = matchers[frame] || matchers.NONE;
    for (let index = 0; index < images.length; index += 1) {
      const url = String(images[index] || '');
      if (patterns.some((pattern) => pattern.test(url))) return index;
    }

    if (frame === 'WHITE') {
      const whiteIndex = images.findIndex((url) => /white/i.test(String(url)));
      if (whiteIndex >= 0) return whiteIndex;
    }

    if (frame === 'BLACK') {
      const blackIndex = images.findIndex((url) => /(?:black|blk)/i.test(String(url)));
      if (blackIndex >= 0) return blackIndex;
    }

    return frame === 'NONE' ? 0 : -1;
  }

  function applyFrameClassToPreview(frameValue) {
    const frameClass = frameClassFor(frameValue);
    document.querySelectorAll('#previewImage, #mySwiperSquare .swiper-slide').forEach((element) => {
      element.classList.remove(...FRAME_CLASSES);
      element.classList.add(frameClass);
    });
  }

  function getMainSwiper() {
    return document.querySelector('#product_hero_images_slider .swiper-container')?.swiper || null;
  }

  function slideMainSwiperTo(index) {
    const swiper = getMainSwiper();
    if (!swiper || index < 0) return;
    swiper.slideTo(index);
    document.dispatchEvent(new Event('updateswiper'));
  }

  function setCustomArtImages(images) {
    customArtState.images = Array.isArray(images) ? images.slice() : [];
  }

  function applyCustomArtFramePreview(frameValue, options = {}) {
    const frame = normalizeFrameValue(frameValue);
    customArtState.frame = frame;
    applyFrameClassToPreview(frame);

    const frameIndex = findFrameImageIndex(customArtState.images, frame);
    if (frameIndex < 0) return;

    if (options.updateSwiper !== false) {
      slideMainSwiperTo(frameIndex);
    }
  }

  window.setCustomArtImages = setCustomArtImages;
  window.applyCustomArtFramePreview = applyCustomArtFramePreview;
  window.getCustomArtFrame = () => customArtState.frame;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function whenLibsReady(fn) {
    let tries = 0;
    const tick = () => {
      if (window.jQuery && window.Swiper) {
        fn(window.jQuery);
        return;
      }
      tries += 1;
      if (tries < 80) window.setTimeout(tick, 50);
    };
    tick();
  }

  function initVisibility($) {
    $('#custom-hidden-option, #custom-hidden-option1, #custom-hidden-option2').hide();
    $('.alloptions').hide();
    $('.myorientation').hide();
    $('#mcOrientation').hide();
    $('#previewPanel').hide();
    $('#swiperPanel').show();
  }

  function initSwipers() {
    const childEl = document.querySelector('#product_hero_images_slider_child');
    const mainEl = document.querySelector('#product_hero_images_slider .swiper-container');
    if (!childEl || !mainEl || !window.Swiper) return;

    const activeIndex = Array.from(mainEl.querySelectorAll('.swiper-slide')).findIndex((slide) =>
      slide.hasAttribute('data-active-slide')
    );

    const child = new window.Swiper('#product_hero_images_slider_child', {
      slidesPerView: 4,
      spaceBetween: 12,
      direction: 'vertical',
      loop: false,
      observer: true,
      observeParents: true,
      watchSlidesProgress: true,
      navigation: {
        nextEl: '.child-navs .swiper-button-next',
        prevEl: '.child-navs .swiper-button-prev',
      },
    });

    const main = new window.Swiper('#product_hero_images_slider .swiper-container', {
      slidesPerView: 1,
      spaceBetween: 0,
      initialSlide: activeIndex >= 0 ? activeIndex : 0,
      pagination: {
        el: '#product_hero_images_slider .swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      thumbs: { swiper: child },
    });

    document.addEventListener('updateswiper', () => {
      main.update();
      child.update();
    });
  }

  ready(() => {
    whenLibsReady(($) => {
      initVisibility($);
      initSwipers();
      applyCustomArtFramePreview(document.querySelector('#hFrame')?.value || 'NONE', { updateSwiper: false });
    });
  });
})();
